import o from "./ghl-ui.es1504.js";
import t from "./ghl-ui.es1574.js";
function f(e, r) {
  if (r && (o(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return t(e);
}
export {
  f as default
};
